import { FileUpload } from '../../biz/FileUpload';

export type FileAndUrl = {
  url: string;
  file: any;
};

export class FileHandler {
  /**
   * 添付ファイルのアップロードとパス返却
   * @returns ファイルのパス情報を返す
   */
  static async fileAttachUpload(user_id: string, attachedFiles: FileAndUrl[]): Promise<string[]> {
    const files: string[] = [];
    for (const file of attachedFiles) {
      const fileService = new FileUpload();
      const response = await fileService.fileUpload(user_id, 'report_attach', file.file);
      files.push(response);
    }
    return files;
  }
}
